import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TimePeriod } from 'ngx-daterangepicker-material/daterangepicker.component';
import { Subscription } from 'rxjs';
import { DataService, ServicecallService } from 'src/app/services';
import { AlertDialogComponent } from '../../../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-entities-catalogue',
  templateUrl: './entities-catalogue.component.html',
  styleUrl: './entities-catalogue.component.css'
})
export class EntitiesCatalogueComponent implements OnInit, OnDestroy {

  entityId = this._router?.url?.split('/')?.[3];
  datepickerForm: FormGroup;
  catalogueTabList: { id: string, label: string }[] = [];
  artifactsTabList: { id: string, label: string }[] = [];
  selectedTabIndex: number = 0;
  selectedArtifactsTabIndex: number = 0;
  vehicleConfigurationsList: { value: string, label: string }[] = [];
  featuresList: { value: string, label: string }[] = [];
  domainEcuList: { value: string, label: string }[] = [];
  networkTopologyList: { value: string, label: string }[] = [];
  artifactsList: { value: string, label: string }[] = [];
  catalogueConfig: any;
  routeData: any;
  historyData: any;
  topologyUrl: string;

  private _subscription: Subscription;
  private _tenantGenericConfig: any;

  constructor(
    public sharedService: ServicecallService,
    private _fb: FormBuilder,
    private _router: Router,
    private _dataSer: DataService,
    private _datePipe: DatePipe,
    private _dialog: MatDialog
  ) {
    this.datepickerForm = this._fb.group({
      thisdate: null
    });

    this.catalogueConfig = this.sharedService?.getConfiguration('catalogueConfig') ?? null;
    this.catalogueTabList = this.catalogueConfig?.catalogueTabList ?? null;
    this.artifactsTabList = this.catalogueConfig?.artifactsTabList ?? null;
    this.vehicleConfigurationsList = this.catalogueConfig?.vehicleConfigurationsOverviewList ?? null;
    this.featuresList = this.catalogueConfig?.featuresList ?? null;
    this.domainEcuList = this.catalogueConfig?.domainEcuList ?? null;
    this.networkTopologyList = this.catalogueConfig?.networkTopologyList ?? null;
    this.artifactsList = this.catalogueConfig?.artifactsList ?? null;
    this.historyData = this.catalogueConfig?.historyData ?? null;

    this.routeData = this._router?.getCurrentNavigation()?.extras?.state?.['data'];
    this._setVehicleConfigDetails();
    this._setTopologyUrl();

    this._subscription = this._dataSer.events.subscribe((res: any) => {
      if (res.name === 'switchToHistoryTab') {
        this.selectedTabIndex = 6;
      }
    });
  }

  ngOnInit(): void {
    this._tenantGenericConfig = this.sharedService?.getConfiguration('tenantGenericConfig') ? this.sharedService.getConfiguration('tenantGenericConfig') : null;
        const defaultStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
    const { startDate, endDate } = this._tenantGenericConfig?.defaultTimeRange
      ? this.sharedService?.calculateDateRange(this._tenantGenericConfig.defaultTimeRange)
      : { startDate: defaultStartDate, endDate: new Date() };

    this.datepickerForm.setValue({
      thisdate: { startDate, endDate }
    });
    this.saveTime();
  }

  ngOnDestroy() {
    this._subscription?.unsubscribe();
  }

  /**
   * Tabs changed
   * @param event 
   */
  tabChanged(event: any) {
    this.selectedTabIndex = event?.index;
    if(this.selectedTabIndex === 1) {
      this.vehicleConfigurationsList = this.catalogueConfig?.vehicleConfigurationsList ?? null;
      this._setVehicleConfigDetails();
    } else if(this.selectedTabIndex === 0) {
      this.vehicleConfigurationsList = this.catalogueConfig?.vehicleConfigurationsOverviewList ?? null;
      this._setVehicleConfigDetails();
    }
  }

  /**
   * Artifacts tab changed
   * @param event 
   */
  artifactsTabChanged(event: any) {
    this.selectedArtifactsTabIndex = event?.index;
  }

  /**
   * Switchs tab
   * @param tab 
   */
  switchTab(tab: number) {
    this.selectedTabIndex = tab;
  }

  /**
   * Tables action
   * @param event 
   */
  tableAction(event: any) {
    if (event?.type === 'catalogueDownload') {
        this._dialog?.open(AlertDialogComponent, {
          data: { msg: 'No records available to download', type: 'hideCancel' },
        });
      }
  }
  
  /**
   * Saves time
   * @param [data] 
   */
  saveTime(data?: any) {
    if (data) {
      let dateRange: TimePeriod = data;
      const offsetTime = new Date().getTimezoneOffset() * 60 * 1000;
      const startDate = this._getTimestampInMillisecond(dateRange?.startDate?.toDate()) + (offsetTime)
      const endDate = this._getTimestampInMillisecond(dateRange?.endDate?.toDate()) + (offsetTime)
      this._dataSer.broadcast('catalogueDateFilterApplied', {
        startDate: this._datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
        endDate: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ')
      });
    } else {
      const defaultStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
      const { startDate, endDate } = this._tenantGenericConfig?.defaultTimeRange
        ? this.sharedService.calculateDateRange(this._tenantGenericConfig.defaultTimeRange)
        : { startDate: defaultStartDate, endDate: new Date() };
      this._dataSer.broadcast('catalogueDateFilterApplied', {
        startDate: this._datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
        endDate: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ')
      });
    }
  }

  /**
   * Handles back
   */
  handleBack() {
    this._router.navigateByUrl(`/vehicles/profile/${this.entityId}`);
  }

  /**
   * Sets topology url
   */
  private _setTopologyUrl() {
  const category = this.routeData?.category;
  const topologyList = this.catalogueConfig?.networkTopologyUrl;

  if (category && Array.isArray(topologyList)) {
    const matchedCategory = topologyList?.find(item => item?.category === category);
    this.topologyUrl = matchedCategory?.url;
  } else {
    this.topologyUrl = "../../../../assets/images/catalogue-topology.svg";
  }
  }

  /**
   * Gets timestamp in millisecond
   * @param date 
   * @returns timestamp in millisecond 
   */
  private _getTimestampInMillisecond(date: Date): number {
    return date ? new Date(date)?.getTime() : 0;
  }

  /**
   * Sets vehicle config details
   */
  private _setVehicleConfigDetails() {
    this.vehicleConfigurationsList = this.vehicleConfigurationsList?.map(item => {
      switch (item?.label) {
        case 'Model Name':
          return { ...item, value: this.routeData?.modelName ?? item?.value };
        case 'Category':
          return { ...item, value: this.routeData?.category ?? item?.value };
        case 'Model Type':
          return { ...item, value: this.routeData?.modelType ?? item?.value };
        case 'Platform Name':
          return { ...item, value: this.routeData?.platformName ?? item?.value }
        default:
          return item;
      }
    });
  }
}
